import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { Component, Input, Output, OnDestroy, OnInit, QueryList, ViewChildren, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/services/sharedService';
import { BaseComponent } from '../../base.component';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { InformationDialogComponent } from '../../dialogs/information-dialog/information-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MapService } from '../../map/map.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-property-tax-form',
  templateUrl: './property-tax-form.component.html',
  styleUrls: ['./property-tax-form.component.css']
})
export class PropertyTaxFormComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  @Input() propertyTaxAttributes
  @Input() propForm
  @Input() processKey
  @Input() processName
  @Input() formEditorConfiguration
  @Input() ccData
  @Input() formCreation
  @Input() currentStage
  @Input() processStageData
  @Input() type
  @Input() id
  @Input() user
  @Input() editedBy
  @Output() onActionStateChange = new EventEmitter<any>();
  selectedTaxPayerTinByIndex = {};
  formValidity = {};
  currentUser
  addProp = false
  constructor(private router: Router, private sharedService: SharedService, private userService: UserService, private propertyTaxService: PropertyTaxService, public dialog: MatDialog, private mapService: MapService) {
    super()
  }

  async ngOnInit() {
    this.currentUser = await this.userService.getCurrentUser().toPromise();
  
    setTimeout(() => {
      this.emitActionState(0);
    });
  
    this.sharedService.formSaveSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.sharedService.addPropertyTax(this.type, 0, {
          taxPayer: this.getSelectedTaxPayer(0, this.processStageData)
        });
      });
  }

  emitActionState(index = 0, prStData = null) {
    const taxPayer = this.getSelectedTaxPayer(index, prStData || this.processStageData);
  
    this.onActionStateChange.emit({
      type: this.type,
      index,
      isValid: this.canSaveOrDeclare(index),
      taxPayer,
      canSave: this.canSaveOrDeclare(index),
      canDeclare: this.canSaveOrDeclare(index) && !!taxPayer,
      id: this.processStageData?._meta?.id || this.processStageData?.id || this.id,
      lotId: this.processStageData?.lot?.id || this.processStageData?._meta?.lotId
    });
  }

  closeAllPanels() {
    if (this.panels && this.panels.length > 0) {
      this.panels.forEach(panel => panel.close());
    } else {
      console.warn('No panels found');
    }
  }

  goToTaxPayer(tin) {
    if (!tin) {
      return;
    }
    this.dialog.closeAll();
    this.router.navigate(['tx_declarations'], {
      queryParams: { tin: tin }
    });
  }

  getSavedTaxPayer(prStData) {
    return prStData && prStData._meta && prStData._meta.taxPayer
      ? prStData._meta.taxPayer
      : null;
  }

  buttonAction(index) {
    if (!this.canSaveOrDeclare(index)) {
      return;
    }
  
    const prStData = this.type === 'BUILDING'
      ? this.processStageData[index]
      : this.processStageData;
  
    const taxPayer = this.getSelectedTaxPayer(index, prStData);
  
    this.sharedService.addPropertyTax(this.type, index, {
      taxPayer
    });
  }
  deleteButton(id, buildingId) {
    if (!id) {
      return;
    }
  
    const countForBuilding = this.processStageData.filter(
      item => item._meta?.buildingId === buildingId
    ).length;
    let deleteAction: Promise<any>;

  if (countForBuilding === 1) {
    deleteAction = this.mapService.deleteBuildingAttributes$(buildingId).toPromise();
    deleteAction = this.propertyTaxService.deletePropertyTax(id).toPromise();
  } else {
    deleteAction = this.propertyTaxService.deletePropertyTax(id).toPromise();
  }
  deleteAction.then(() => {
    this.processStageData = this.processStageData.filter(item => item._meta?.id !== id);
    this.sharedService.closePropertyTaxForm();
    this.dialog.open(InformationDialogComponent, {
      width: "500px",
      disableClose: true,
      data: { text: "DIALOG.PROP_TAX_DELETED" }
    });
  }).catch(err => {
    console.error("Delete failed:", err);
  });
  }
  changeStage(stg, index) {
    this.sharedService.changeStage({ stg, index })
  }
  addNew() {
    this.closeAllPanels()
    this.addProp = true
  }
  onTaxpayerSelected(taxpayer, index = 0) {
  this.selectedTaxPayerTinByIndex[index] = taxpayer && taxpayer.tin ? taxpayer.tin : null;
  this.emitActionState(index);
  }

  isReadonlyRole() {
    return this.currentUser?.role === 'PROPERTIES_LECTEUR'
      || this.currentUser?.role === 'FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR'
      || this.currentUser?.role === 'MAYOR_TREASURER_AND_PROPERTIES_LECTEUR';
  }
  
  getSelectedTaxPayer(index, prStData = null) {
    if (Object.prototype.hasOwnProperty.call(this.selectedTaxPayerTinByIndex, index)) {
      return this.selectedTaxPayerTinByIndex[index];
    }
  
    return this.getSavedTaxPayer(prStData);
  }
  
  canSaveOrDeclare(index) {
    return this.formValidity[index] === true;
  }
  
  canDeclare(index, prStData = null) {
    return this.canSaveOrDeclare(index)
      && !!this.getSelectedTaxPayer(index, prStData)
      && !this.isReadonlyRole()
      && this.currentUser?.role !== 'AGENT_RECENSEUR';
  }
  
  onFormValidityChange(isValid, index) {
    setTimeout(() => {
      this.formValidity[index] = isValid;
      this.emitActionState(index);
    });
  }
  declareProperty(prStData, index) {
    if (!this.canDeclare(index, prStData)) {
      return;
    }
  
    const taxPayer = this.getSelectedTaxPayer(index, prStData);
  
    this.sharedService.addPropertyTax(this.type, index, {
      taxPayer,
      declare: true
    });
  }
  
}
